////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const campaignPrice = {
	getCampaign: (idCampaign) => ({
		type: ActionsTypes.GET_CAMPAIGN,
		payload: {
			idCampaign,
		},
	}),
	getCampaignSuccess: (data) => ({
		type: ActionsTypes.GET_CAMPAIGN_SUCCESS,
		payload: {
			data,
		},
	}),
	getCampaignFailure: (error) => ({
		type: ActionsTypes.GET_CAMPAIGN_FAILURE,
		payload: {
			error,
		},
	}),
	createCampaign: (campaign, action) => ({
		type: ActionsTypes.CREATE_CAMPAIGN,
		payload: {
			campaign,
			action,
		},
	}),
	createCampaignSuccess: (campaign) => ({
		type: ActionsTypes.CREATE_CAMPAIGN_SUCCESS,
		payload: {
			campaign,
		},
	}),
	createCampaignFailure: (error) => ({
		type: ActionsTypes.CREATE_CAMPAIGN_FAILURE,
		payload: {
			error,
		},
	}),
	resetCampaign: () => ({
		type: ActionsTypes.RESET_CAMPAIGN,
		payload: {},
	}),
	checkCampaign: (campaign, target) => ({
		type: ActionsTypes.POST_CHECK_CAMPAIGN,
		payload: {
			campaign,
			target,
		},
	}),
	checkCampaignSuccess: (campaign) => ({
		type: ActionsTypes.POST_CHECK_CAMPAIGN_SUCCESS,
		payload: {
			campaign,
		},
	}),
	checkCampaignFailure: (error) => ({
		type: ActionsTypes.POST_CHECK_CAMPAIGN_FAILURE,
		payload: {
			error,
		},
	}),
	updateCampaign: (idCampaign, data) => ({
		type: ActionsTypes.UPDATE_CAMPAIGN,
		payload: {
			idCampaign,
			data,
		},
	}),
	updateCampaignSuccess: (data, idCampaign) => ({
		type: ActionsTypes.UPDATE_CAMPAIGN_SUCCESS,
		payload: {
			data,
			idCampaign,
		},
	}),
	updateCampaignFailure: (error) => ({
		type: ActionsTypes.UPDATE_CAMPAIGN_FAILURE,
		payload: {
			error,
		},
	}),
	cancelCampaign: (idCampaign) => ({
		type: ActionsTypes.CANCEL_CAMPAIGN,
		payload: {
			idCampaign,
		},
	}),
	cancelCampaignSuccess: (data, idCampaign) => ({
		type: ActionsTypes.CANCEL_CAMPAIGN_SUCCESS,
		payload: {
			data,
			idCampaign,
		},
	}),
	cancelCampaignFailure: (error) => ({
		type: ActionsTypes.CANCEL_CAMPAIGN_FAILURE,
		payload: {
			error,
		},
	}),
	resetCampaignItems: () => ({
		type: ActionsTypes.RESET_CAMPAIGN_ITEMS,
	}),
}

export default campaignPrice
